import { LicenseSeatsManagementController as controller } from './license-seats-management.controller';
import template from './license-seats-management.component.html';

export const licenseSeatsManagement = {
	controller,
	template
};
